const reviews = [
  {
    id: 1,
    name: "Sarah Mitchell",
    book: "The Turner's Saga",
    quote: "Cameron's writing has transformed my spiritual journey. The Turner's Saga is a masterpiece that I couldn't put down.",
    rating: 5
  },
  {
    id: 2,
    name: "David Thompson",
    book: "Bible Story Heroes For Kids",
    quote: "The coloring books are not just art - they're meditation tools. I find such peace in each page.",
    rating: 5
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    book: "My Jesus My Journal",
    quote: "My Jesus My Journal has become my daily companion. Cameron has an incredible gift for creating meaningful spiritual tools.",
    rating: 5
  },
  {
    id: 4,
    name: "Michael Chen",
    book: "AI Income Generator",
    quote: "The AI Income Generator opened my eyes to opportunities I never imagined. Practical and enlightening.",
    rating: 5
  },
  {
    id: 5,
    name: "Jessica Anderson",
    book: "Escape From Tehran",
    quote: "Escape From Tehran is an epic adventure that had me on the edge of my seat. Can't wait for more!",
    rating: 5
  },
  {
    id: 6,
    name: "Robert Williams",
    book: "The Camp Cookbook",
    quote: "These books have become essential reading in our book club. Cameron's insights spark the best discussions.",
    rating: 5
  }
];

export default reviews;
